import { IEnvironmentEntity } from '../environment';

export enum BiTokenContext {
	USER_TOKEN = 'USER_TOKEN',
	REPORT_TOKEN = 'REPORT_TOKEN',
	GROUP_TOKEN = 'GROUP_TOKEN',
}

export enum BiReportType {
	SALES_REPORT = 'SALES_REPORT',
	DEMAND_REPORT = 'DEMAND_REPORT',
	ACCURACY_REPORT = 'ACCURACY_REPORT',
}

export const biExplorer: IEnvironmentEntity = {
	development: {
		url:
			process.env.REACT_APP_BI_DOMINIO ||
			'https://easy360.reportload.com',
	},
	staging: {
		url:
			process.env.REACT_APP_BI_DOMINIO ||
			'https://easy360.reportload.com',
	},
	production: {
		url:
			process.env.REACT_APP_BI_DOMINIO ||
			'https://easy360.reportload.com',
	},
};
